module.exports = __webpack_public_path__ + "img/printer-outline-black.9519c60f.svg";